export default "__VITE_ASSET__DqcHGceA__"